import React from 'react'
import assets from '../utils/assets';
import styles from "../pages/pages.module.scss";

const PollGraph = () => {
  return (
    <img src={assets.payrollchart} alt="" className={`img-fluid ${styles.mHeight194}`} />
  )
}

export default PollGraph;